import { Component } from '@angular/core';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { ControlPageStore, PollutantCategory } from '@pages/control-page/control-page-store.service';
import { Enums } from 'constants/Enums.constant';
import { combineLatest, map } from 'rxjs';

const POLLUTANT_MAP: Record<PollutantCategory, {color: string, backgroundColor: string, label: string}> = {
  [PollutantCategory.HAZARDOUS]: {
    color: 'transparent',
    backgroundColor: 'transparent',
    label: 'station-app.__GAUGE_AIRNOW_6',
  },
  [PollutantCategory.VERYUNHEALTHY]: {
    color: 'var(--red-alert)',
    backgroundColor: 'var(--red-alert-transparent)',
    label: 'station-app.__GAUGE_AIRNOW_5',
  },
  [PollutantCategory.UNHEALTHY]: {
    color: 'var(--amnesty-purple)',
    backgroundColor: 'var(--amnesty-purple-transparent)',
    label: 'station-app.__GAUGE_AIRNOW_4',
  },
  [PollutantCategory.UNHEALTHYFORSENSITIVE]: {
    color: 'var(--orange-alert)',
    backgroundColor: 'var(--orange-alert-transparent)',
    label: 'station-app.__GAUGE_AIRNOW_3',
  },
  [PollutantCategory.MODERATE]: {
    color: 'var(--yellow)',
    backgroundColor: 'var(--yellow-transparent)',
    label: 'station-app.__GAUGE_AIRNOW_2',
  },
  [PollutantCategory.GOOD]: {
    color: 'var(--green-confirmation)',
    backgroundColor: 'var(--green-confirmation-transparent)',
    label: 'station-app.__GAUGE_AIRNOW_1',
  },
  [PollutantCategory.UNKNOWN]: {
    color: '',
    backgroundColor: '',
    label: '--',
  },
};

@Component({
  selector: 'app-outdoor-air-quality',
  templateUrl: './outdoor-air-quality.component.html',
  styleUrls: ['./outdoor-air-quality.component.scss']
})
export class OutdoorAirQualityComponent {

  private pollutant$ = this.controlPageStore.forecast$.pipe(
    isDefined(),
    map(forecast => forecast.airqdatav2?.pollutants.find(p => p.type === 'pm2.5') ?? null),
  );

  private display$ = this.sidebarRoomService.roomModules$.pipe(
    map(modules => modules.map(m => m.type).includes(Enums.ModuleType.NAMODULE1)),
  );

  viewModel$ = combineLatest({
    display: this.display$,
    pollutant: this.pollutant$,
  });

  POLLUTANT_MAP = POLLUTANT_MAP;

  constructor(
    private controlPageStore: ControlPageStore,
    private sidebarRoomService: SidebarRoomService,
  ) { }

}
